import styled, { css } from 'styled-components';
import NavItem from 'gatsby-theme-menus/src/components/nav/list-nav/nav-item';

export default styled(NavItem)`
  ${({ $hasColumn }) => $hasColumn && css`
    position: static;
  `}
`;
